import React, {useEffect, useState} from 'react';
import {Link, withRouter} from 'react-router-dom';
import Layout from "../../components/Layout";
import LanguageContext from '../../helper/LanguageContext';
import {Animated} from "react-animated-css";
import * as moment from "moment";
import { goBack} from "../../helper/constants";
import {EN} from '../../Languages/EN';
import {DE} from '../../Languages/DE';
import { convertMonths } from '../../helper/convertor';
import "./WeeklyStatistics.css";


function WeeklyStatistics(props) {
    const {isGerm, strings} = React.useContext(LanguageContext);
    const [visible, setVisible] = useState(true);
    const [news, setNews] = useState({});
    const handleBack = () => {
        setVisible(false);
        setTimeout(() => {
            goBack();
        }, 1000)
    };
    useEffect(() => {
        const {news} = props.location.state;
        console.log(news);
        setNews(news)
    }, []);

    return (
        <React.Fragment>
            <Layout>
                <Animated animationIn="slideInLeft" animationOutDuration={800} animationOut="slideOutLeft" isVisible={visible}>
                    <div className="w-300 capacities_content-page contact_page pb-0">
                        <h5 className="pb-2">
                            <img className="pointer" onClick={handleBack} width={10} src={process.env.PUBLIC_URL + "assets/img/back.svg"}
                                 alt="Generic placeholder"/> {strings.weekly_statistics}</h5>
                        <div className="my-scroll min_height">
                            <div className="row m-0">
                                <div className="col-12">
                                    <h2 className="m-0">{news.count}</h2>
                                </div>
                                <div className="col-12">
                                    <p className="m-0">{strings.times_you_have_appeared_in_searches}</p>
                                    <p className="m-0">({convertMonths(news.fromDate,isGerm)} - {convertMonths(news.date,isGerm)})</p>
                                </div>
                                <div className="col-12 mt-4 text-center">
                                    <img
                                        width={40}
                                        height={40}
                                        className="mr-3"
                                        src={process.env.PUBLIC_URL + "/assets/img/search.svg"}
                                        alt="Generic placeholder"
                                    />
                                    <p className="font-weight-bold">{strings.appear_more_often_in_searches}</p>
                                    <p>
                                        {strings.you_have_been_found} {news.count} {strings.times_in_searches_in_the_last_week}
                                    </p>
                                </div>
                                <div className="col-12 text-center weekly-statistics__cta">
                                    <Link to="/profile"><button type="button" className="kj-btn kj-btn--outline">{strings.improve_profile}</button></Link>

                                </div>
                            </div>
                        </div>
                    </div>
                </Animated>
            </Layout>
        </React.Fragment>
    );
}

export default withRouter(WeeklyStatistics);
